import { Injectable } from '@angular/core';
import { Constants } from '@local/common';
import { CanActivateViewGuard } from './can-activate-view.guard';

@Injectable()
export class CanActivateFavoritesGuard extends CanActivateViewGuard {
  protected flag = Constants.DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG;
}
